// extracted by mini-css-extract-plugin
export default {"rating":"KJ-z","numberOfStars":"LJ-z","count":"MJ-z","barGraphSpacing":"NJ-z","barGraph":"OJ-z"};